@if (src && src !== '') {
    <span>
        <img [src]="src" alt='' [style.width.px]="width" [style.height]="height > 0 ? height + 'px' : 'auto'" />
    </span>
}
